import { useContext, useEffect, useState } from 'react';
import { Context } from '../context';
import { isPortrait } from './get-orientation';
import { useBreakpoint } from './use-breakpoint';
import { AssetHelper } from '../helper/assetHelper';
import { Fallback, ThemeScroll } from '../FeatureAppTypes';

export const useFallbackImage = (fallback: Fallback, theme: ThemeScroll) => {
  const { logger } = useContext(Context);
  const [image, setImage] = useState<string>();

  const breakpoint = useBreakpoint(theme);
  const imageSrc = isPortrait() ? fallback.portrait : fallback.landscape;

  useEffect(() => {
    if (breakpoint !== 0) {
      setImage(`${AssetHelper.getImageUrl(imageSrc, logger)}?width=${breakpoint}`);
    }
  }, [breakpoint, imageSrc]);

  return image;
};
